// extracted by mini-css-extract-plugin
export var statItem = "_c2-1";
export var statsRow = "_c2-0";